import { gql } from '@apollo/client';
export const SCHOOL_FIELDS = gql `
  fragment SchoolFields on School {
    id
    countryId
    name
    location
    type
    accredited
    accreditationIds
    clientId
    clientName
    countryName
    countryCode
    accreditations {
      id
      name
    }
    source
    isActive
    createdAt
    updatedAt
  }
`;
export const SCHOOLS = gql `
  ${SCHOOL_FIELDS}
  query SCHOOLS($spec: SchoolSpec!) {
    schools(spec: $spec) {
      total
      page
      pageSize
      items {
        ...SchoolFields
      }
    }
  }
`;
export const GET_SCHOOL_COUNTRY = gql `
  query GET_SCHOOL_COUNTRY($name: String!) {
    getSchoolCountry(name: $name) {
      countryCode
      countryId
      schoolName
      schoolId
    }
  }
`;
export const SAVE_SCHOOL = gql `
  ${SCHOOL_FIELDS}
  mutation SAVE_SCHOOL($input: SchoolInput!) {
    saveSchool(input: $input) {
      ...SchoolFields
    }
  }
`;
export const DELETE_SCHOOL = gql `
  mutation DELETE_SCHOOL($id: Int!) {
    deleteSchool(id: $id) {
      success
      messages {
        value
        type
        params
      }
    }
  }
`;
export const UPDATE_SCHOOL = gql `
  mutation UPDATE_SCHOOL($input: SchoolUpdateInput!, $spec: SchoolSpec!) {
    updateSchool(input: $input, spec: $spec) {
      success
      messages {
        value
        type
        params
      }
    }
  }
`;
